import RuleMessage from './RuleMessage';

export default RuleMessage;
